import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types';

const ReCAPTCHAComponent = ({ onChange, sitekey }) => {
  const recaptchaRef = useRef(null);

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={
        sitekey ||
        process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY ||
        '6Le9AygqAAAAAD_bHjq6FGmiX0T0-lE3OOBU4lUF'
      }
      onChange={onChange}
    />
  );
};

ReCAPTCHAComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  sitekey: PropTypes.string,
};

export default ReCAPTCHAComponent;
